var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraRetake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "retakeimage-a",
    d: "M32,0 C14.326888,0 0,14.326888 0,32 C0,49.673112 14.326888,64 32,64 C49.673112,64 64,49.673112 64,32 C64,14.326888 49.673112,0 32,0 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "retakeimage-b",
    width: "106.2%",
    height: "106.2%",
    x: "-3.1%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#26436F",
    xlinkHref: "#retakeimage-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#retakeimage-b)",
    xlinkHref: "#retakeimage-a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20,6.66666667 C12.6666667,6.66666667 6.66666667,12.6666667 6.66666667,20 C6.66666667,27.3333333 12.6666667,33.3333333 20,33.3333333 C26.1666667,33.3333333 31.3333333,29 33.3333333,23.3333333 L30,23.3333333 C28,27.1666667 24.3333333,30 20,30 C14.5,30 10,25.5 10,20 C10,14.5 14.5,10 20,10 C22.8333333,10 25.1666667,11.1666667 26.6666667,13.3333333 L21.6666667,18.3333333 L33.3333333,18.3333333 L33.3333333,6.66666667 L30,10 C27,8.33333333 23.6666667,6.66666667 20,6.66666667 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraRetake);
export default __webpack_public_path__ + "static/media/camera_retake.3beb27392af888be171fb4538ed407de.svg";
export { ForwardRef as ReactComponent };